import config from './config';

class WidgetMode {
  static isRepresentationMode() {
    return !this.isDealerMode();
  }

  static isDealerMode() {
    const { dealerExternalId, dealer } = config.all();
    return dealerExternalId || dealer;
  }
}

export default WidgetMode;